// The target weight follows the dose (save() of the local app, D-B01 of APP-PARITY.md "Detail-Abgleich"): stopping by
// weight with a quick choice chosen, a new dose keeps that recipe's ratio, so the target goes along in the same set.
import { findCommand } from '@brewcore/protocol';
import type { ParamValue } from '../store.js';
import { goalOf, parsePresets, presetActive, ratioOf, stopModeOf } from '../recipe.js';
import type { ScreenContext, Values } from './context.js';

/**
 * The extra values of a dose change: the target weight at the same ratio (prototype "Rezept", 21.10.2026: "Das
 * Zielgewicht ergibt sich aus Dosis und Verhältnis"), the chosen quick choice's ratio when one is chosen, or nothing.
 * `before` reads the values without the stepper's collected dose (the recipe is the one before the change).
 */
export function doseExtra(ctx: ScreenContext, before: Values): (dose: number) => Record<string, ParamValue> {
  return (dose): Record<string, ParamValue> => {
    if (stopModeOf(before, ctx.scale) !== 'weight') return {};
    const oldDose = Number(before('brew.dose') ?? 18) || 18;
    const presets = parsePresets(before('brew.presets'), oldDose);
    const chosen = presets.find((p) => presetActive(p, before, ctx.scale));
    const ratio = chosen?.r ?? ratioOf(oldDose, Number(before('brew.by_weight.target_weight') ?? 0));
    if (!ratio) return {};
    const c = findCommand(ctx.catalog, 'brew.by_weight.target_weight');
    const goal = Math.min(c?.max ?? Infinity, Math.max(c?.min ?? -Infinity, goalOf(ratio, dose)));
    const now = Number(before('brew.by_weight.target_weight') ?? 0);
    return Math.abs(goal - now) > 0.01 ? { 'brew.by_weight.target_weight': goal } : {};
  };
}
